module.exports = __webpack_public_path__ + "img/2_uk.ebc87c15.svg";